import { render, staticRenderFns } from "./ReceiptTable.vue?vue&type=template&id=c6cdb52e&scoped=true&"
import script from "./ReceiptTable.vue?vue&type=script&lang=js&"
export * from "./ReceiptTable.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptTable.vue?vue&type=style&index=0&id=c6cdb52e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cdb52e",
  null
  
)

export default component.exports